import { Subscription } from 'rxjs';
import { StatesService } from './../../services/states.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { IndicatorsService } from 'src/app/services/indicators.service';

import * as moment from 'moment';

@Component({
  selector: 'main-indicators',
  templateUrl: './indicators.component.html',
  styleUrls: ['./indicators.component.scss']
})
export class IndicatorsComponent implements OnInit {

  @Output() indicatorScreen = new EventEmitter();
  private subscription: Subscription;
  public dateSetup: any;
  public atual: number;

  public loading: boolean;
  public indicList: [];
  public date: number = 30;
  
  constructor(private _indicatorsService: IndicatorsService,
    private _stateService: StatesService) {
    this.loading = true;
    this.indicList = []
  }

  ngOnInit(): void {
    this.subscription = this._stateService.currentDate.subscribe(res => {
      this.dateSetup = res;
      this.getIndicators();
    });
    this._stateService.currentSelected.subscribe(res => {
      this.atual = res;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  changeDate(data){
    this._stateService.changeSelected(4);
    if(data.targetElement.id === 'dataFinal' && data.value !== null){
      document.querySelector('.indiSelect') ? document.querySelector('.indiSelect').classList.remove('indiSelect') : null;
      this._stateService.changeDate(
        {
          start_date : this.dateSetup.start_date._d,
          end_date: this.dateSetup.end_date._d
        }
      );
    }
  }

  getIndicators(){
    this.indicList = [];
    this.loading = true;
    this._indicatorsService.getIndicators(this.dateSetup.start_date, this.dateSetup.end_date).subscribe(data => {
      this.indicList = data.data;
      this.loading = false;
    });
  }

  closeIndicatorScreen(){
    this.indicatorScreen.emit();
  }

  timeFilterSet(type, el){
    if(document.querySelector('.indiSelect') !== null){
      document.querySelector('.indiSelect').classList.remove('indiSelect');
    }
    el.currentTarget.classList.add('indiSelect');
    switch (type) {
      case 'hoje':
        this._stateService.changeDate(
          {
            start_date : moment(new Date()).startOf('day').toDate(),
            end_date: moment(new Date()).endOf('day').toDate()
          }
        );
        this._stateService.changeSelected(0);
        break;
      case 'sete':
        this._stateService.changeDate(
          {
            start_date : moment(new Date()).subtract(7, 'days').toDate(),
            end_date: moment(new Date()).endOf('day').toDate()
          }
        );
        this._stateService.changeSelected(1);
        break;
      case 'esteMes':
        this._stateService.changeDate(
          {
            start_date : moment(new Date()).startOf('month').toDate(),
            end_date: moment(new Date()).endOf('month').toDate()
          }
        );
        this._stateService.changeSelected(2);
        break;
      case 'mesAntes':
        this._stateService.changeDate(
          {
            start_date : moment(new Date()).subtract(1, 'month').startOf('month').toDate(),
            end_date: moment(new Date()).subtract(1, 'month').endOf('month').toDate()
          }
        );
        this._stateService.changeSelected(3);
        break;
      default:
        this._stateService.changeDate(
          {
            start_date : moment(new Date()).subtract(7, 'days').toDate(),
            end_date: moment(new Date()).endOf('day').toDate()
          }
        );
        this._stateService.changeSelected(0);
        break;
    }
  }

}
